import { render, staticRenderFns } from "./DoubleClickEditText.vue?vue&type=template&id=13942f83&"
import script from "./DoubleClickEditText.vue?vue&type=script&lang=ts&"
export * from "./DoubleClickEditText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports